const EventEmitter = require('eventemitter3');

const sideMenu = document.querySelector('.sidemenu');
const menuTrigger = document.querySelector('.sandwich');
const mainMenu = document.querySelector('.menu');
const emitter = new EventEmitter();

const toggleMenu = () => {
	menuTrigger.classList.toggle('not-active');
    mainMenu.classList.toggle('show');
    if (mainMenu.classList.contains('show'))
        emitter.emit('activated');
    else
        emitter.emit('deactivated');
}

menuTrigger.addEventListener('click', () => {
    toggleMenu();
})

const _show = () => {
    menuTrigger.classList.add('not-active');
    sideMenu.classList.add('load');
 }

const menuLinks = [...mainMenu.querySelectorAll('.menu__list-item')];

menuLinks.forEach(link => {
	link.addEventListener('click', () => {
		toggleMenu();
        emitter.emit('request', link.dataset.link);
	})
})

/*
mainMenu.addEventListener('click', e => {
	if (e.target.classList.contains('menu__list-item')) {return;}
	toggleMenu();
})
*/

emitter.show = _show;
module.exports = emitter;




// WEBPACK FOOTER //
// ./js/viscom/vereschagin/side_menu.js